/**
 * Builds a full name from first, middle, and last name parts.
 * Filters out empty/null/undefined values to avoid double spaces
 * when middle name is not present.
 */
export function buildFullName(firstName, middleName, lastName) {
  return [firstName, middleName, lastName].filter(Boolean).join(" ");
}
